import GenerateSingularOrPlural from './generateSingularOrPlural.utility';

class MonthSingularOrPlural extends GenerateSingularOrPlural {
  singularWord = 'month';

  pluralWord = 'months';
}

export default MonthSingularOrPlural;
